/**
 * The 10 Soap Showdown experiments.
 *
 * Each experiment: 1 teaspoon of `name`, then a dab of dishwashing detergent added.
 * `id` is the stable, permanent identifier used everywhere (video files, Supabase rows,
 * vote tallies). Never renumber or reorder existing ids — the bracket order shown to
 * visitors is randomised separately at runtime and does not depend on this array order.
 *
 * `slug` is the stable text key stored in the database (readable + safe to reference
 * in SQL seed data without relying on numeric ids matching across environments).
 *
 * Video/poster paths point at /public/videos and /public/posters. Drop the real footage
 * in using these exact filenames and everything else works unchanged.
 */
export const INGREDIENTS = [
  { id: 1, slug: 'cinnamon', name: 'Cinnamon' },
  { id: 2, slug: 'blue-food-colouring', name: 'Blue food colouring' },
  { id: 3, slug: 'oregano', name: 'Oregano' },
  { id: 4, slug: 'baby-powder', name: 'Baby powder' },
  { id: 5, slug: 'extra-virgin-olive-oil', name: 'Extra virgin olive oil' },
  { id: 6, slug: 'turmeric', name: 'Turmeric' },
  { id: 7, slug: 'ground-coffee', name: 'Ground coffee' },
  { id: 8, slug: 'salt', name: 'Salt' },
  { id: 9, slug: 'tajin-with-lime', name: 'Tajín with lime' },
  { id: 10, slug: 'parsley', name: 'Parsley' },
].map((ingredient) => ({
  ...ingredient,
  video: `/videos/${ingredient.slug}.mp4`,
  poster: `/posters/${ingredient.slug}.jpg`,
}));

export const INGREDIENT_BY_ID = new Map(INGREDIENTS.map((i) => [i.id, i]));
export const INGREDIENT_BY_SLUG = new Map(INGREDIENTS.map((i) => [i.slug, i]));

export const TOTAL_EXPERIMENTS = INGREDIENTS.length;
export const TOTAL_ROUNDS = TOTAL_EXPERIMENTS - 1;
